import React from 'react'

import ConnectWallet from '@src/components/buttons/ConnectWallet'
import PointIcon from '@src/components/icons/Point'
import SandDollarIcon from '@src/components/icons/SandDollar'

export const RewardsConnectWallet: React.FC = () => {
    const name = window.location.href.includes('hourglass') ? 'Hourglass' : 'Mach'

    return (
        <div className='flex h-full w-[432px] flex-col items-center gap-6 rounded-xl bg-[#111112] px-4 py-10'>
            <div className='flex flex-col items-center gap-4'>
                <div className='inline-flex items-start'>
                    <PointIcon height='80' width='80' />
                    <SandDollarIcon height='80' width='80' />
                </div>
                <div className='flex flex-col gap-2'>
                    <div className='w-[252px] text-center text-[30px] font-medium leading-9 text-white'>
                        Welcome to {name} Rewards
                    </div>
                    <div className='w-[252px] text-center text-sm font-medium leading-5 text-[#757575]'>
                        Connect your EVM wallet to view your rewards current amount
                    </div>
                </div>
                <ConnectWallet
                    enforceEVM={true}
                    className='!inline-flex !h-auto !items-center !gap-2 !rounded-[10px] !bg-[#155DFC] !p-2.5'
                >
                    <div className='relative h-6 w-6 overflow-hidden'>
                        <div className='absolute left-0.5 top-[7px] h-2.5 w-3 outline outline-2 outline-offset-[-1px] outline-white' />
                        <div className='absolute left-[10px] top-[7px] h-2.5 w-3 outline outline-2 outline-offset-[-1px] outline-white' />
                    </div>
                    <span className='text-center text-base font-medium leading-6 text-white'>Connect wallet</span>
                </ConnectWallet>
            </div>
        </div>
    )
}
